module.exports = __webpack_public_path__ + "static/media/DSC_9719.09a86638.jpg";